module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "LoginForm"
  }, [(_vm.isLoggedIn) ? _c('p', {
    staticClass: "text-right margin-a-z"
  }, [_c('span', {
    staticClass: "margin-r-xs"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('customerForm.not')) + "\n      " + _vm._s(_vm.firstName) + "?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logoutSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.signOut')))])]) : _c('p', {
    staticClass: "text-right margin-a-z"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('customerForm.alreadyHave')) + "\n    "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showHideForm
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.signIn2')))])]), _vm._v(" "), _c('div', {
    class: ['login-form showhide-fadeslide', (_vm.isHidden ? 'hide' : '')]
  }, [_c('div', {
    class: ['padding-a-m', _vm.isSafari]
  }, [_c('form', {
    class: ['showhide-fadeslide', (_vm.hideLogin ? 'hide' : '')],
    attrs: {
      "action": "#",
      "data-vv-scope": "login-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginSubmit($event)
      }
    }
  }, [_c('div', {
    class: _vm.isSafari
  }, [(_vm.flashData.type == 'login') ? _c('div', {
    class: ['alert-wrap showhide-fadeslide', (_vm.flashData.message === '' ? 'hide' : '')]
  }, [_c('div', {
    class: ['alert margin-b-s', (_vm.loginResponse), _vm.isSafari]
  }, [_vm._v("\n              " + _vm._s(_vm.flashData.message) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 column padding-r-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.email
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.emailUsername')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    class: ['field-text', (_vm.isLoading ? 'disabled' : '')],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "johndoe@gmail.com",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.email),
      expression: "error.email"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "medium-6 columns padding-l-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.password
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('common.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: ['field-text', (_vm.isLoading ? 'disabled' : '')],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.password),
      expression: "error.password"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.password))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showHideForgotPassword('show')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.forgotPass')))])]), _vm._v(" "), _c('div', {
    staticClass: "medium-6 columns margin- t-m"
  }, [_c('button', {
    class: ['op-btn btn-success btn-lg f-right', (_vm.isLoading ? 'loading' : '')]
  }, [_c('span', {
    staticClass: "original-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.signIn2')))]), _vm._v(" "), _c('div', {
    staticClass: "loaderx"
  }, [_c('icon', {
    staticClass: "magin-r-xs",
    attrs: {
      "name": "refresh",
      "spin": ""
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.loading')) + "\n              ")], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns"
  }, [_c('forgot-password-form', {
    ref: "forgotPasswordForm",
    attrs: {
      "showForm": [_vm.hideLogin ? '' : 'hide'],
      "flash": _vm.flash
    },
    on: {
      "hideForgotPassword": _vm.hideForgotPassword
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCorporate),
      expression: "isCorporate"
    }],
    staticClass: "corporate-box row"
  }, [_c('div', {
    staticClass: "medium-1 column"
  }, [_c('img', {
    attrs: {
      "src": _vm.corporateData.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "medium-11 column"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.corporateAccnt')))]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.corporateData.name))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-066fe48d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066fe48d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/LoginForm.vue
// module id = 2029
// module chunks = 0